// src/context/StaticTextContext.jsx

import React, { createContext, useContext, useEffect, useState } from "react";
import axios from "axios";
import { useLanguage } from "./LanguageContext";

const StaticTextContext = createContext();

export const StaticTextProvider = ({ children }) => {
  const { lang } = useLanguage();
  const [texts, setTexts] = useState(null); // منتظر دریافت API می‌مانیم

  useEffect(() => {
    axios
      .get(`${process.env.REACT_APP_API_BASE_URL}/site-setting/`)
      .then((res) => {
        console.log("✅ Site static texts loaded:", res.data);
        setTexts(res.data);
      })
      .catch((err) => console.error("❌ StaticTextContext Error:", err));
  }, []);

  if (!texts) return null; // تا زمان لود، چیزی نمایش داده نمی‌شود

  const getText = (key) =>
    lang === "fa" ? texts[`${key}_fa`] : texts[`${key}_en`];

  const contextValue = {
    contact_us_title: getText("contact_us_title"),
    phone_label: getText("phone_label"),
    email_label: getText("email_label"),
    address_label: getText("address_label"),
    toggle_theme_dark: getText("toggle_theme_dark"),
    toggle_theme_light: getText("toggle_theme_light"),
    footer_text: getText("footer_text"),
    site_name: getText("site_name"),
    logo: texts.logo,
    phone_number: texts.phone_number,
    email: texts.email,
    address: getText("address"),
    view_project_button: getText("view_project_button"),
    latest_projects_title: getText("latest_projects_title"),
    year_label: getText("year_label"),

    contact_profile_image: texts.contact_profile_image,
    contact_name_placeholder: getText("contact_name_placeholder"),
    contact_email_placeholder: getText("contact_email_placeholder"),
    contact_phone_placeholder: getText("contact_phone_placeholder"),
    contact_subject_placeholder: getText("contact_subject_placeholder"),
    contact_message_placeholder: getText("contact_message_placeholder"),
    contact_submit_text: getText("contact_submit_text"),
    contact_success_message: getText("contact_success_message"),
    contact_error_message: getText("contact_error_message"),
    popup_close_button: getText("popup_close_button"),
    telegram_link: texts.telegram_link,
    instagram_link: texts.instagram_link,
    linkedin_link: texts.linkedin_link,
    github_link: texts.github_link,

  };

  return (
    <StaticTextContext.Provider value={contextValue}>
      {children}
    </StaticTextContext.Provider>
  );
};

export const useStaticTexts = () => useContext(StaticTextContext);
